import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import NextStep from '@/models/NextStep';
import { RouteNames } from '@/enums/routes/RouteNames';
import { ProjectTabValues } from '@/enums/components/Project/ProjectTabValues';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityMessage',
  props: {
    activity: {
        type: Object as PropType<NextStep>,
        required: true,
    },
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
},
  setup(__props) {

const props = __props;



const projectRoute = computed(() => ({
    name: RouteNames.project,
    params: {
        id: props.selectedProjectId,
    },
    query: {
        initialTab: `${ProjectTabValues.Basic}`,
    },
}));

const formattedReminderDate = computed(() => {
    if (props.activity.reminderDate === '-') {
        return '-';
    }

    return moment(props.activity.reminderDate).format('DD.MM.YYYY HH:mm');
});

return { __sfc: true,props, projectRoute, formattedReminderDate }
}

})